import { NgModule } from '@angular/core';
import { CustomlibCheckingComponent } from './customlib-checking.component';



@NgModule({
  declarations: [CustomlibCheckingComponent],
  imports: [
  ],
  exports: [CustomlibCheckingComponent]
})
export class CustomlibCheckingModule { }
